const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic bab purchase flow
if (window.location.pathname.includes("/products/")) {
  waitForElement(".awtomic-sw__price-current", () => {
    let lastVariant = new URLSearchParams(location.search).get("variant");

    const checkVariant = () => {
      const variant = new URLSearchParams(location.search).get("variant");

      if (variant !== lastVariant) {
        location.reload();
      }
    };

    const pushState = history.pushState;
    history.pushState = (...args) => {
      pushState.apply(history, args);
      checkVariant();
    };

    const replaceState = history.replaceState;
    history.replaceState = (...args) => {
      replaceState.apply(history, args);
      checkVariant();
    };

    window.addEventListener("popstate", checkVariant);
  });
}


/* === Primal - Awtomic customer portal polish (path-gated, added via Claude) ===
   Tokens taken from config/settings_data.json on 2026-08-10, NOT hand-picked:
     color_background_main  #EEEDEA   (was cream #f9f6f1 here, the retired value)
     color_accent_main      #202020
     color_text_main        #2a2a2a
     border_radius_buttons  30
     border_radius_cards    16
     theme_max_width        1500
   Only styles Awtomic's own portal at /tools/bundle-subscriptions. The Shopify
   hosted sign-in at account.primalwine.com is NEW_CUSTOMER_ACCOUNTS and cannot
   be reached from here; brand that in Admin > Settings > Customer accounts. */
(function(){
  if (!location.pathname.includes('/tools/bundle-subscriptions')) return;
  var prev=document.querySelector('style[data-primal-portal]'); if(prev) prev.remove();
  var css = [
    /* ground */
    "body{background-color:#EEEDEA !important;}",
    ".bundleapp-subscriptions-wrapper{max-width:1500px !important;}",
    /* type */
    ".bundle-text--heading{color:#202020 !important;}",
    ".bundle-text--body{color:#2a2a2a !important;}",
    ".bundle-text--heading,.bundle-text--body,.bundle-button{font-family:Inter,-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif !important;}",
    /* buttons: theme pill radius */
    ".bundle-button{border-radius:30px !important;}",
    ".bundle-button.button--primary{background-color:#202020 !important;border-color:#202020 !important;color:#fff !important;}",
    ".bundle-action-button-container button:not(.bundle-button--skip){background-color:#202020 !important;border-color:#202020 !important;color:#fff !important;border-radius:30px !important;}",
    ".bundle-button.button--secondary,.bundle-button--skip{color:#202020 !important;border-color:rgba(32,32,32,.22) !important;background:transparent !important;}",
    /* add-on cards: theme card radius + hairline */
    ".bundle-product-card{box-sizing:border-box !important;border:1px solid rgba(32,32,32,.12) !important;border-radius:16px !important;padding:14px !important;background:#fff !important;display:flex !important;flex-direction:column !important;}",
    ".bundle-product-card__subtitle{min-height:2.6em;}",
    ".bundle-product-card .button--primary{margin-top:auto !important;}",
    ".bundle-product-card .bundle-text--body{margin-top:8px !important;}",
    /* section boxes */
    ".bundle-card{border:1px solid rgba(32,32,32,.12) !important;border-radius:16px !important;background:#fff !important;}",
    /* de-thicken faux-bold mono */
    ".pw-code{font-weight:500 !important;letter-spacing:.04em !important;}",
    ".bundle-subs-detail-layout *,.bundle-card *,.pw-codebox,.pw-code{font-synthesis:none;}"
  ].join("\n");
  var s=document.createElement('style'); s.setAttribute('data-primal-portal','1'); s.textContent=css; document.head.appendChild(s);
})();
